import React from "react";
//import store from '../store.js'
//import {loadConsults} from 'actionsCreators.js';
import 'antd/dist/antd.css';

import { MDBInput, MDBNavbar, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon, MDBSideNavItem, MDBSideNavCat, MDBSideNavNav, MDBSideNav, MDBContainer } from "mdbreact";
import history from '../history';
import store from '../store';
import { logOut, getCursosActivos } from '../actionCreators';

import { BrowserRouter as Router } from 'react-router-dom';

class MasterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      breakWidth: 1300,
      windowWidth: 0,
      isOpenMenuTop: true,
      contenido: 1,
      activeItemClassicTabs1: "1",
      listItems: this.props.listItems,
      txtoem: "",
      collapsed: false,
      isOpen: false,
      toggleStateA: false

    };
  }

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  handleToggleClickA = () => {
    this.setState({
      toggleStateA: !this.state.toggleStateA
    });
  };


  render() {
    const navStyle = {
      paddingLeft:
        this.state.windowWidth > this.state.breakWidth ? "10px" : "16px"
    };


    const specialCaseNavbarStyles = {
      WebkitBoxOrient: "horizontal",
      flexDirection: "row"
    };

    console.log("state", this.state.toggleStateA)
    {/*<img src="logomenu.png" style={{ width: '200px', cursor: 'pointer' }} ></img>*/ }
    return (

      <div className="mdb-skin">
        <MDBSideNav
          logo={"rev.png"}

          triggerOpening={this.state.toggleStateA}
          mask="strong"
          className={this.state.toggleStateA ? "abrirMenu" : "cerrarMenu"}
          hidden >

          <MDBSideNavItem style={{ color: '#000' }} onClick={this.handleToggleClickA}> <MDBIcon icon="window-close" className="d-inline-inline" />{" "}Cerrar menú</MDBSideNavItem>




          <MDBSideNavNav>
            <MDBSideNavItem onClick={() => { getCursosActivos(); history.push("/dashboard"); }}>Registro</MDBSideNavItem>
            <MDBSideNavItem>Cursos</MDBSideNavItem>
            <MDBSideNavItem>Preferencias</MDBSideNavItem>
            <MDBSideNavItem>Forma de pago</MDBSideNavItem>
            <MDBSideNavItem>Temario</MDBSideNavItem>
            <MDBSideNavItem>Tipos de curso</MDBSideNavItem>
            <MDBSideNavItem>Zonas</MDBSideNavItem>
            <MDBSideNavItem>Agrupaciones</MDBSideNavItem>

          </MDBSideNavNav>

        </MDBSideNav>

        <MDBNavbar double expand="md" fixed="top" scrolling>
          <MDBNavbarNav left style={{ marginTop: '5px' }}>
            <MDBNavItem>
              <div
                onClick={this.handleToggleClickA}
                key="sideNavToggleA"
                style={{
                  lineHeight: "32px",
                  marginRight: "1em",
                  verticalAlign: "middle"
                }}
              >
                <MDBIcon icon="bars" color="white" size="2x" />
              </div>
            </MDBNavItem>
            <MDBNavItem className="d-none d-md-inline" style={{ paddingTop: 5, fontSize: '18px' }}>
              Registro Reevolución
              </MDBNavItem>
          </MDBNavbarNav>
          <MDBNavbarNav right style={specialCaseNavbarStyles}>

            <MDBNavItem active onClick={() => { logOut(); history.push({ pathname: "/" }); localStorage.clear(); store.dispatch({ type: "STATE_ALL_USER", allDataUser: {} }) }}>
              <MDBNavLink to="#!">
                <MDBIcon icon="window-close" className="d-inline-inline" />{" "}
                <div className="d-none d-md-inline">Cerrar Sesión </div>
              </MDBNavLink>
            </MDBNavItem>
            {/* 
              <MDBNavItem>
                <MDBNavLink to="#!">
                  <MDBIcon far icon="comments" className="d-inline-inline" />{" "}
                  <div className="d-none d-md-inline">Support</div>
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem>
                <MDBNavLink to="#!">
                  <MDBIcon icon="user" className="d-inline-inline" />{" "}
                  <div className="d-none d-md-inline">Account</div>
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem>
                <MDBDropdown>
                  <MDBDropdownToggle nav caret>
                    <div className="d-none d-md-inline">Dropdown</div>
                  </MDBDropdownToggle>
                  <MDBDropdownMenu right>
                    <MDBDropdownItem href="#!">Action</MDBDropdownItem>
                    <MDBDropdownItem href="#!">Another Action</MDBDropdownItem>
                    <MDBDropdownItem href="#!">Something else here</MDBDropdownItem>
                    <MDBDropdownItem href="#!">Something else here</MDBDropdownItem>
                  </MDBDropdownMenu>
                </MDBDropdown>
              </MDBNavItem>
 */}

          </MDBNavbarNav>
        </MDBNavbar>




        {/*
        <MDBNavbar style={{backgroundColor:'#182848'}} dark expand="sm" fixed="top">
      
          <MDBNavbarToggler onClick={this.toggleCollapse} />
          <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>

            <MDBNavbarNav right>
              <MDBNavItem onClick={() => {logOut(); history.push({ pathname: "/" }); localStorage.clear(); }}>
                <MDBNavLink to="">
                  <MDBIcon far icon="window-close" className="d-inline-inline " />
                  <span className="mr-2">Cerrar Sesión</span>
                </MDBNavLink>
              </MDBNavItem>
            </MDBNavbarNav>

          </MDBCollapse>
        </MDBNavbar>

 */}

      </div>
    );
  }
}

export default MasterPage;